import { cn } from '@aibi/ui';
import { ChevronDown } from 'lucide-react';
import { useId, useState, type ReactNode } from 'react';

export interface ExplorerSectionProps {
  readonly title: string;
  readonly count?: number;
  readonly children: ReactNode;
  readonly defaultOpen?: boolean;
  readonly actions?: ReactNode;
}

/** Seccion plegable del explorador con encabezado accesible (`aria-expanded`). */
export function ExplorerSection({
  title,
  count,
  children,
  defaultOpen = true,
  actions,
}: ExplorerSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const contentId = useId();
  return (
    <section className="py-1">
      <div className="flex items-center gap-1 px-1">
        <button
          type="button"
          aria-expanded={open}
          aria-controls={contentId}
          className="flex flex-1 items-center gap-1 rounded-md px-1 py-1 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring"
          onClick={() => {
            setOpen((value) => !value);
          }}
        >
          <ChevronDown
            aria-hidden
            className={cn('size-3 transition-transform', !open && '-rotate-90')}
          />
          {title}
          {count !== undefined && <span className="font-normal normal-case">({count})</span>}
        </button>
        {actions}
      </div>
      <div id={contentId} hidden={!open} className="px-1 pt-0.5">
        {children}
      </div>
    </section>
  );
}
